export default __webpack_public_path__ + "static/media/cast.c1d2a993.svg";